import React, { ReactNode } from 'react';

import PropTypes from 'prop-types';

import { LinkButton } from '@adsk/alloy-react-button';
import { useLocale } from '@adsk/alloy-react-locale';
import { useTheme } from '@adsk/alloy-react-styles';
import { stylePropType, StylableComponent } from '@adsk/alloy-react-theme';

type DefaultContentSmallProps = StylableComponent<HTMLDivElement> & {
  open?: () => void;
  disabled?: boolean;
  title?: ReactNode;
  linkText?: ReactNode;
};

const DefaultContentSmall = React.forwardRef<
  HTMLDivElement,
  DefaultContentSmallProps
>(({ style, className, open, disabled, title, linkText }, ref) => {
  const theme = useTheme();
  const contentSmallTokens =
    theme.tokens?.component?.dropzone?.['content-small'];
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));

  return (
    <div ref={ref} css={[contentSmallTokens, style]} className={className}>
      {(title || T.translate('DRAG_FILES_HERE_OR')) + ' '}
      <LinkButton
        disabled={disabled}
        onClick={(e) => {
          open && open();
          // that is because the entire dropzone is clickable
          e.stopPropagation();
        }}
      >
        {linkText || T.translate('CHOOSE_FILES_LOWER')}
      </LinkButton>
    </div>
  );
});

DefaultContentSmall.displayName = 'DefaultContentSmall';

DefaultContentSmall.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Function that opens file browser */
  open: PropTypes.func,
  /** Whether dropzone is disabled */
  disabled: PropTypes.bool,
};

export default DefaultContentSmall;
